import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './auth/base-api.service';
import { KeyVaultKeys } from '../utils/enums/key-vault-keys.enum';

export interface KeyVaultSecretResponse {
    secret: string | null;
    id: string | null;
    devToken: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class KeyVaultService extends BaseApiService {
    private get baseUrl(): string {
        return `${environment.connectedApiUrls.woland}/${environment.apiVersions.woland}`;
    }

    constructor() {
        super(inject(HttpClient));
    }

    async getCredentials(keys: KeyVaultKeys[]): Promise<Record<string, KeyVaultSecretResponse>> {
        return this.get<Record<string, KeyVaultSecretResponse>>(`${this.baseUrl}/KeyVault?${this.toQueryParams({ keys })}`);
    }
}
